import Vue from 'vue'
import VueRouter from 'vue-router'
import AnswView from '@/views/AnswView.vue'

Vue.use(VueRouter)

const routes = [
  //预约提交
  {
    path: '/',
    component: AnswView
  },
]

const router = new VueRouter({
  routes: routes,
  mode: "history"
})

export default router
